import React, { useContext, useEffect, useState } from "react";
import ProfileHeader from "../components/Profile/StudentProfile/ProfileHeader";
import { fetchUserProfile } from "../services/profile/profileService"; // Importing the merged fetch function
import InstructorCourseList from "../components/Profile/TeacherProfile/InstructorCourseList";
import { AuthContext } from "../context/AuthContext";
import { toast } from "react-toastify";
import { getApi } from "../services/api";
import { BASE_UPLOADS } from "../utils/constants";
import SimplethreeDot from "../components/common/Loadinganimations/SimplethreeDot";

function TeachersProfile() {
	const [teacherProfile, setTeacherProfile] = useState(null);
	const [assignedClassrooms, setAssignedClassrooms] = useState([]);
	const { user, loading } = useContext(AuthContext);
	const userId = user?._id;

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Fetching teacher profile using the generic fetchUserProfile
				const profileData = await fetchUserProfile(userId, "teacher");
				// Fetching courses taught by the teacher using CourseListService
				// const coursesData =
				// 	await CourseListService.getCoursesByTeacherId(userId);
				const classroomData = await getApi("/classrooms", {
					filter: JSON.stringify({ userId }),
				});
				setTeacherProfile(profileData);
				setAssignedClassrooms(classroomData); // Update state with courses data
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};
		if (!loading) {
			fetchData();
		}
	}, [userId, loading]);

	const handleProfileUpdate = (updatedData) => {
		setTeacherProfile((prev) => ({
			...prev,
			fullName: updatedData.name,
			email: updatedData.email,
			phone: updatedData.phone,
			profilePic: updatedData.profilePic,
		}));
		toast.success("Profile updated successfully!");
	};

	if (!teacherProfile) {
		return <SimplethreeDot />;
	}

	return (
		<div className="max-w-4xl mx-auto my-8 font-sans p-4 bg-white rounded-lg shadow-lg pt-4 mt-20">
			<ProfileHeader
				name={teacherProfile.fullName} // Adjusted to match API response
				email={teacherProfile.email}
				phone={teacherProfile.phone} // Added phone prop
				profilePic={teacherProfile.profilePic} // Adjusted to match API response
				userId={userId} // Pass userId for updates
				onProfileUpdated={handleProfileUpdate} // Callback for handling updates
			/>
			<InstructorCourseList classrooms={assignedClassrooms} />
		</div>
	);
}

export default TeachersProfile;
